import { IPartner } from 'clickNgo/entities/partner/models'

export const filterExternalPartners = (
  apolloPartnerList: IPartner[],
  partnerRequestList: IPartner[]
) =>
  apolloPartnerList.filter(
    ({ partnerId }) => !partnerRequestList.find((partner) => partner.partnerId === partnerId)
  )
